import {
  type AccessibilityWizardPanelState,
  type InitialData,
} from '@wix/a11y-wizard';

import type { Shell } from 'repluggable';

import type { A11yWizardStateAPI } from './a11y-wizard-state-api';
import { a11yWizardActions, createA11yWizardSelector } from './store';
import type { A11yWizardScopedState } from './store';

export const createA11yWizardStateAPI = (shell: Shell): A11yWizardStateAPI => {
  const store = shell.getStore<A11yWizardScopedState>();
  const selectors = createA11yWizardSelector(
    () => store.getState().a11yWizardState,
  );
  return {
    setInitialData: (initialData: InitialData | undefined) =>
      store.dispatch(a11yWizardActions.setInitialData(initialData)),
    getInitialData: selectors.getInitialData,
    setPanelState: (panelState: AccessibilityWizardPanelState | undefined) =>
      store.dispatch(a11yWizardActions.setPanelState(panelState)),
    getPanelState: selectors.getPanelState,
  };
};
